import { render, staticRenderFns } from "./idCardT.vue?vue&type=template&id=f194f3f2&scoped=true&"
import script from "./idCardT.vue?vue&type=script&lang=js&"
export * from "./idCardT.vue?vue&type=script&lang=js&"
import style1 from "./idCardT.vue?vue&type=style&index=1&id=f194f3f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f194f3f2",
  null
  
)

export default component.exports